module.exports = __webpack_public_path__ + "media/images/bg_service_access-2fef76eed5b8adf89f0101513498a117.jpg";